/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  NormalizedBase,
  NormalizedApiResponse,
  RawBaseWsData,
  RawDroneWsMessage,
} from '../types/dashboard';
import {
  applyBaseWsUpdateToBases,
  applyDroneWsUpdateToBases,
  mergeApiResponseIntoBases,
} from '../utils/dashboard';

interface DashboardState {
  bases: NormalizedBase[];
  metricsStartDate: string | null;
  metricsEndDate: string | null;
}

const initialState: DashboardState = {
  bases: [],
  metricsStartDate: null,
  metricsEndDate: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setBasesAndMissionMetricsFromApi(
      state,
      action: PayloadAction<NormalizedApiResponse>
    ) {
      state.bases = mergeApiResponseIntoBases(
        action.payload.bases,
        state.bases
      );
      state.metricsStartDate = action.payload.startDate;
      state.metricsEndDate = action.payload.endDate;
    },
    applyDroneWsUpdate(state, action: PayloadAction<RawDroneWsMessage>) {
      state.bases = applyDroneWsUpdateToBases(state.bases, action.payload);
    },
    applyBaseWsUpdate(state, action: PayloadAction<RawBaseWsData>) {
      state.bases = applyBaseWsUpdateToBases(state.bases, action.payload);
    },
    resetDashboard() {
      return initialState;
    },
  },
});

export const {
  setBasesAndMissionMetricsFromApi,
  applyDroneWsUpdate,
  applyBaseWsUpdate,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
